import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { t } from 'i18next';
import { SVGIcon } from './x2bim_utility_components';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ThemeProvider } from '@emotion/react';
import theme from '../layout/theme';
import { Container, Paper } from '@mui/material';

import accuount from "../../public/assets/faq_text_contents/account.json"
import accuracy from "../../public/assets/faq_text_contents/accuracy.json"
import support from "../../public/assets/faq_text_contents/support.json"
import technical from "../../public/assets/faq_text_contents/technical.json"
import data from "../../public/assets/faq_text_contents/data.json"
import use_cases from "../../public/assets/faq_text_contents/use_cases.json"
import involvement_project from "../../public/assets/faq_text_contents/involvement_project.json"
import use_base from "../../public/assets/faq_text_contents/use_base.json"
import legal_basis from "../../public/assets/faq_text_contents/legal_basis.json"
import { useTranslation } from 'react-i18next';
import { Info, InfoOutlined, InfoRounded, InfoTwoTone } from '@mui/icons-material';
import {useLocation, useNavigate} from "react-router-dom";

export default function FAQPopup() {
  const { i18n, t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  const handleClose = () => {
    if (location.key !== 'default') {
      navigate(-1)
    } else {
      navigate("/")
    }
  };

  const sections = [
    {
      title: "Information zum Account/Login",
      questions: accuount
    },
    {
      title: "Information zur Genauigkeit der Daten",
      questions: accuracy
    },
    {
      title: "Information zur Generalthemen/Kontakt/Support",
      questions: support
    },
    {
      title: "Technisches",
      questions: technical
    },
    {
      title: "Daten",
      questions: data
    },
    {
      title: "Informationen zu Anwendungsfällen",
      questions: use_cases
    },

    {
      title: "Informationen zur Einbindung in Projekte",
      questions: involvement_project
    },

    {
      title: "Informationen zur Nutzung der Plattform",
      questions: use_base
    },
    {
      title: "Informationen zu rechtlichen Grundlagen",
      questions: legal_basis
    },
  ]

  const helpClick = () => {
    const lang = i18n ? i18n.language : "en"
    window.open(`https://www.x2bim.com/resources/manuals/X2BIM_manual_${lang == "de" ? "de" : "en"}.pdf`, "_blank");
  }

  return (
      <Dialog
        fullScreen
        open={true}
        onClose={handleClose}
        TransitionComponent={Slide}
        TransitionProps={{ direction: "up" }}
      >
        <AppBar sx={{ position: 'relative' }} color='dark'>
          <Toolbar>
           
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              FAQs
            </Typography>

            <Button autoFocus color="inherit" onClick={helpClick}>
              {t("leftNav.userManual")}
            </Button>

            <IconButton
              edge="end"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Container sx={{ mt: 4 }}>
          <Box >
            <Stack spacing={2}>
              {sections.map((section) => {

                return (
                  <Accordion key={section.title} defaultExpanded={true}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant='h5'>
                        {section.title}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{boxShadow:0}}>
                      {section.questions.map((question, index) => {
                        return (
                          <Accordion key={question}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                              <Typography>{question.question}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                            
                                {question.answer}

                                {question.image && <Box component="img" sx={{ ml: 30, mt: 1 }} src={`/${question.image}`} />}
                            
                            </AccordionDetails>
                          </Accordion>
                        )

                      })}
                    </AccordionDetails>

                  </Accordion>
                )
              })}
            </Stack>
          </Box>
        </Container>
      </Dialog>
  );
}